<template>
  <div>
    <div class="text-white header"><slot name="header"></slot></div>
    <div v-if="editMode" class="d-flex align-items-center">
      <b-input type="number" class="input-header" placeholder="Часы" size="sm" min="0" v-model.number="newHours"></b-input>
      <b-input type="number" class="input-header" placeholder="Минуты" size="sm" min="0" v-model.number="newMinutes"></b-input>
      <el-button
        class="no-outline ml-1 micro-button"
        icon="el-icon-check"
        type="success"
        @click="saveChanges()"
        size="mini"
        circle
      ></el-button>
      <el-button
        class="no-outline ml-1 micro-button"
        icon="el-icon-close"
        type="danger"
        @click="cancelEdit()"
        size="mini"
        circle
      ></el-button>
    </div>
    <div v-else  class="d-flex align-items-center">
      <span class="timing">
        {{hours}} ч.
        {{minutes}} м.
      </span>
      <el-button class="no-outline ml-2 micro-button" icon="el-icon-edit" type="primary" @click="startEdit()"
                 size="mini" circle></el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeDeliveryForm',
  props: {
    currentValue: Object,
    editedValue: String
  },
  data () {
    return {
      newMinutes: null,
      newHours: null,
      editMode: false
    }
  },
  methods: {
    startEdit () {
      this.editMode = true
      this.newMinutes = this.minutes
      this.newHours = this.hours
    },
    cancelEdit () {
      this.editMode = false
    },
    saveChanges () {
      this.$emit('updated-time', {minutes: this.newMinutes, hours: this.newHours})
      this.cancelEdit()
    }
  },
  computed: {
    minutes () {
      return this.currentValue ? this.currentValue.timeInterval.minutes : 0
    },
    hours () {
      return this.currentValue ? this.currentValue.timeInterval.hours : 0
    }
  }
}
</script>

<style scoped>
  .timing {
    color: white;
  }
  .input-header {
    width:100px;
  }
  .header {
    font-size: 0.7rem;
  }
  .micro-button {
    padding: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TimeDeliveryForm.vue